export const XERO_INVOICE_HOST = 'in.xero.com';
export const XERO_INVOICE_PROTOCOL = 'https:';
